import { useAuthentication } from '@speeki/firebase-chat';

import { ExchangeFirebaseTokenDocument } from '@graphql/generated/graphql';

import { useMutation } from '@apollo/client';

export const useLoginToFirebase = () => {
    const [getFirestoreToken] = useMutation(ExchangeFirebaseTokenDocument, {
        onError: () => {},
    });
    const { firebaseAuthentication, signOut } = useAuthentication();
    const loginToFirebase = async () => {
        try {
            const RES = await getFirestoreToken();
            await firebaseAuthentication(RES.data?.exchangeFirebaseToken.token);
        } catch (e) {
            console.error(e);
            return e;
        }
    };
    return { loginToFirebase, signOut };
};
